module.exports = __webpack_public_path__ + "static/img_2.dea10354.png";